import { createAction } from 'redux-actions';

// User signature action types
export const FETCH_USER_SIGNATURES_REQUEST = 'FETCH_USER_SIGNATURES_REQUEST';
export const FETCH_USER_SIGNATURES_SUCCESS = 'FETCH_USER_SIGNATURES_SUCCESS';
export const FETCH_USER_SIGNATURES_FAILURE = 'FETCH_USER_SIGNATURES_FAILURE';

export const CREATE_USER_SIGNATURE_REQUEST = 'CREATE_USER_SIGNATURE_REQUEST';
export const CREATE_USER_SIGNATURE_SUCCESS = 'CREATE_USER_SIGNATURE_SUCCESS';
export const CREATE_USER_SIGNATURE_FAILURE = 'CREATE_USER_SIGNATURE_FAILURE';

export const UPDATE_USER_SIGNATURE_REQUEST = 'UPDATE_USER_SIGNATURE_REQUEST';
export const UPDATE_USER_SIGNATURE_SUCCESS = 'UPDATE_USER_SIGNATURE_SUCCESS';
export const UPDATE_USER_SIGNATURE_FAILURE = 'UPDATE_USER_SIGNATURE_FAILURE';

export const DELETE_USER_SIGNATURE_REQUEST = 'DELETE_USER_SIGNATURE_REQUEST';
export const DELETE_USER_SIGNATURE_SUCCESS = 'DELETE_USER_SIGNATURE_SUCCESS';
export const DELETE_USER_SIGNATURE_FAILURE = 'DELETE_USER_SIGNATURE_FAILURE';

export const SET_DEFAULT_USER_SIGNATURE_REQUEST = 'SET_DEFAULT_USER_SIGNATURE_REQUEST';
export const SET_DEFAULT_USER_SIGNATURE_SUCCESS = 'SET_DEFAULT_USER_SIGNATURE_SUCCESS';
export const SET_DEFAULT_USER_SIGNATURE_FAILURE = 'SET_DEFAULT_USER_SIGNATURE_FAILURE';

// System signature action types
export const FETCH_SYSTEM_SIGNATURES_REQUEST = 'FETCH_SYSTEM_SIGNATURES_REQUEST';
export const FETCH_SYSTEM_SIGNATURES_SUCCESS = 'FETCH_SYSTEM_SIGNATURES_SUCCESS';
export const FETCH_SYSTEM_SIGNATURES_FAILURE = 'FETCH_SYSTEM_SIGNATURES_FAILURE';

export const CREATE_SYSTEM_SIGNATURE_REQUEST = 'CREATE_SYSTEM_SIGNATURE_REQUEST';
export const CREATE_SYSTEM_SIGNATURE_SUCCESS = 'CREATE_SYSTEM_SIGNATURE_SUCCESS';
export const CREATE_SYSTEM_SIGNATURE_FAILURE = 'CREATE_SYSTEM_SIGNATURE_FAILURE';

export const UPDATE_SYSTEM_SIGNATURE_REQUEST = 'UPDATE_SYSTEM_SIGNATURE_REQUEST';
export const UPDATE_SYSTEM_SIGNATURE_SUCCESS = 'UPDATE_SYSTEM_SIGNATURE_SUCCESS';
export const UPDATE_SYSTEM_SIGNATURE_FAILURE = 'UPDATE_SYSTEM_SIGNATURE_FAILURE';

export const DELETE_SYSTEM_SIGNATURE_REQUEST = 'DELETE_SYSTEM_SIGNATURE_REQUEST';
export const DELETE_SYSTEM_SIGNATURE_SUCCESS = 'DELETE_SYSTEM_SIGNATURE_SUCCESS';
export const DELETE_SYSTEM_SIGNATURE_FAILURE = 'DELETE_SYSTEM_SIGNATURE_FAILURE';

export const SET_DEFAULT_SYSTEM_SIGNATURE_REQUEST = 'SET_DEFAULT_SYSTEM_SIGNATURE_REQUEST';
export const SET_DEFAULT_SYSTEM_SIGNATURE_SUCCESS = 'SET_DEFAULT_SYSTEM_SIGNATURE_SUCCESS';
export const SET_DEFAULT_SYSTEM_SIGNATURE_FAILURE = 'SET_DEFAULT_SYSTEM_SIGNATURE_FAILURE';

// UI action types
export const SET_SELECTED_SIGNATURE_ID = 'SET_SELECTED_SIGNATURE_ID';
export const CLEAR_SIGNATURE_ERRORS = 'CLEAR_SIGNATURE_ERRORS';

// User signature actions
export const fetchUserSignaturesRequest = createAction(FETCH_USER_SIGNATURES_REQUEST);
export const fetchUserSignaturesSuccess = createAction(FETCH_USER_SIGNATURES_SUCCESS);
export const fetchUserSignaturesFailure = createAction(FETCH_USER_SIGNATURES_FAILURE);

export const createUserSignatureRequest = createAction(CREATE_USER_SIGNATURE_REQUEST);
export const createUserSignatureSuccess = createAction(CREATE_USER_SIGNATURE_SUCCESS);
export const createUserSignatureFailure = createAction(CREATE_USER_SIGNATURE_FAILURE);

export const updateUserSignatureRequest = createAction(UPDATE_USER_SIGNATURE_REQUEST);
export const updateUserSignatureSuccess = createAction(UPDATE_USER_SIGNATURE_SUCCESS);
export const updateUserSignatureFailure = createAction(UPDATE_USER_SIGNATURE_FAILURE);

export const deleteUserSignatureRequest = createAction(DELETE_USER_SIGNATURE_REQUEST);
export const deleteUserSignatureSuccess = createAction(DELETE_USER_SIGNATURE_SUCCESS);
export const deleteUserSignatureFailure = createAction(DELETE_USER_SIGNATURE_FAILURE);

export const setDefaultUserSignatureRequest = createAction(SET_DEFAULT_USER_SIGNATURE_REQUEST);
export const setDefaultUserSignatureSuccess = createAction(SET_DEFAULT_USER_SIGNATURE_SUCCESS);
export const setDefaultUserSignatureFailure = createAction(SET_DEFAULT_USER_SIGNATURE_FAILURE);

// System signature actions
export const fetchSystemSignaturesRequest = createAction(FETCH_SYSTEM_SIGNATURES_REQUEST);
export const fetchSystemSignaturesSuccess = createAction(FETCH_SYSTEM_SIGNATURES_SUCCESS);
export const fetchSystemSignaturesFailure = createAction(FETCH_SYSTEM_SIGNATURES_FAILURE);

export const createSystemSignatureRequest = createAction(CREATE_SYSTEM_SIGNATURE_REQUEST);
export const createSystemSignatureSuccess = createAction(CREATE_SYSTEM_SIGNATURE_SUCCESS);
export const createSystemSignatureFailure = createAction(CREATE_SYSTEM_SIGNATURE_FAILURE);

export const updateSystemSignatureRequest = createAction(UPDATE_SYSTEM_SIGNATURE_REQUEST);
export const updateSystemSignatureSuccess = createAction(UPDATE_SYSTEM_SIGNATURE_SUCCESS);
export const updateSystemSignatureFailure = createAction(UPDATE_SYSTEM_SIGNATURE_FAILURE);

export const deleteSystemSignatureRequest = createAction(DELETE_SYSTEM_SIGNATURE_REQUEST);
export const deleteSystemSignatureSuccess = createAction(DELETE_SYSTEM_SIGNATURE_SUCCESS);
export const deleteSystemSignatureFailure = createAction(DELETE_SYSTEM_SIGNATURE_FAILURE);

export const setDefaultSystemSignatureRequest = createAction(SET_DEFAULT_SYSTEM_SIGNATURE_REQUEST);
export const setDefaultSystemSignatureSuccess = createAction(SET_DEFAULT_SYSTEM_SIGNATURE_SUCCESS);
export const setDefaultSystemSignatureFailure = createAction(SET_DEFAULT_SYSTEM_SIGNATURE_FAILURE);

// UI actions
export const setSelectedSignatureId = createAction(SET_SELECTED_SIGNATURE_ID);
export const clearSignatureErrors = createAction(CLEAR_SIGNATURE_ERRORS);